var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sidebar-right",
    {
      class: [
        "navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--720",
        { open: _vm.show },
      ],
      on: { overlayClicked: _vm.outside },
    },
    [
      _c("div", { staticClass: "bg-white md__card--holder" }, [
        _c("div", { staticClass: "card" }, [
          _c(
            "div",
            {
              staticClass: "card-header",
              class: {
                "blue-class": _vm.$route.name == "projects",
                "green-class": _vm.$route.name == "tasks.home",
                "yellow-class": _vm.$route.name == "timesheet.home",
              },
            },
            [
              _c("h4", { staticClass: "h3 mb-0" }, [
                _vm._v(_vm._s(_vm.editTitle)),
              ]),
            ]
          ),
          _c("div", { staticClass: "card-body" }, [
            _c(
              "form",
              { staticClass: "hideBlockParent" },
              [
                _c("div", { staticClass: "form-group mb-4" }, [
                  _c("label", [_vm._v("Name")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.task.name,
                        expression: "task.name",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "exampleFormControlInput1",
                      type: "text",
                      placeholder: "Task Name",
                    },
                    domProps: { value: _vm.task.name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.task, "name", $event.target.value)
                      },
                    },
                  }),
                ]),
                _c(
                  "div",
                  { staticClass: "form-group mb-4" },
                  [
                    _c("label", [_vm._v("Description")]),
                    _c("html-editor", {
                      attrs: { value: "" },
                      model: {
                        value: _vm.task.description,
                        callback: function ($$v) {
                          _vm.$set(_vm.task, "description", $$v)
                        },
                        expression: "task.description",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "row mx-0 mb-4 mt-4" }, [
                  _c("div", { staticClass: "col ml-0 px-0" }, [
                    _c("h4", { staticClass: "h3 mb-0" }, [_vm._v("Quote")]),
                  ]),
                  _c("div", { staticClass: "col-auto px-0" }, [
                    _c("label", { staticClass: "custom-toggle" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.task.has_quote,
                            expression: "task.has_quote",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          "data-toggle": "collapse",
                          id: "checkQuote",
                          "data-target": "#quote",
                          "aria-expanded": "false",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.task.has_quote)
                            ? _vm._i(_vm.task.has_quote, null) > -1
                            : _vm.task.has_quote,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.task.has_quote,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.task,
                                    "has_quote",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.task,
                                    "has_quote",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.task, "has_quote", $$c)
                            }
                          },
                        },
                      }),
                      _c("span", {
                        staticClass: "custom-toggle-slider rounded-circle",
                        attrs: {
                          "data-label-off": "OFF",
                          "data-label-on": "ON",
                        },
                      }),
                    ]),
                  ]),
                ]),
                _vm.task.has_quote
                  ? _c(
                      "div",
                      { staticClass: "mb-4", attrs: { id: "hiddenParrent" } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "w-100 collapse show tabToggle",
                            attrs: { id: "quote" },
                          },
                          [
                            _c(
                              "ul",
                              {
                                staticClass: "nav tabPanel mb-3",
                                attrs: { role: "tablist" },
                              },
                              _vm._l(_vm.resources, function (res, ind) {
                                return _c(
                                  "li",
                                  { key: ind, staticClass: "mr-5" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-radio",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.task.resource,
                                              expression: "task.resource",
                                            },
                                          ],
                                          staticClass: "custom-control-input",
                                          attrs: {
                                            id: ind,
                                            name: "resource",
                                            type: "radio",
                                          },
                                          domProps: {
                                            value: res,
                                            checked: _vm._q(
                                              _vm.task.resource,
                                              res
                                            ),
                                          },
                                          on: {
                                            change: [
                                              function ($event) {
                                                return _vm.$set(
                                                  _vm.task,
                                                  "resource",
                                                  res
                                                )
                                              },
                                              _vm.onResourceChanged,
                                            ],
                                          },
                                        }),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "custom-control-label",
                                            attrs: { for: ind },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(res.name) +
                                                "\n                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                            _c("div", { staticClass: "tab-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "tab-pane fade active show",
                                  attrs: { id: "rate", role: "tabpanel" },
                                },
                                [
                                  _c("div", { staticClass: "px-0" }, [
                                    _c("div", { staticClass: "form-row" }, [
                                      _c(
                                        "label",
                                        { staticClass: "col-md-12" },
                                        [_vm._v("Rate & Hours")]
                                      ),
                                      _c("div", { staticClass: "col-md-6" }, [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.task.hourly_cost,
                                                  expression:
                                                    "task.hourly_cost",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                placeholder: "Rate",
                                              },
                                              domProps: {
                                                value: _vm.task.hourly_cost,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.task,
                                                    "hourly_cost",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]),
                                      _c("div", { staticClass: "col-md-6" }, [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.task.quoted_hours,
                                                  expression:
                                                    "task.quoted_hours",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                placeholder: "Hour(s)",
                                              },
                                              domProps: {
                                                value: _vm.task.quoted_hours,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.task,
                                                    "quoted_hours",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "form-group mb-4" }, [
                  _c("label", [_vm._v("Month(s)")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.task.months,
                        expression: "task.months",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      name: "month",
                      placeholder: "Number of Month",
                    },
                    domProps: { value: _vm.task.months },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.task, "months", $event.target.value)
                      },
                    },
                  }),
                ]),
                _c(
                  "div",
                  { staticClass: "form-group mb-4" },
                  [
                    _c("base-input", {
                      attrs: {
                        alternative: "",
                        "prepend-icon": "ni ni-calendar-grid-58",
                        label: "Deadline",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ focus, blur }) {
                            return _c("flat-picker", {
                              staticClass: "form-control datepicker",
                              attrs: { config: { allowInput: true } },
                              on: { "on-open": focus, "on-close": blur },
                              model: {
                                value: _vm.task.deadline,
                                callback: function ($$v) {
                                  _vm.$set(_vm.task, "deadline", $$v)
                                },
                                expression: "task.deadline",
                              },
                            })
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _c(
                  "base-button",
                  {
                    staticClass: "my-4 btn-block",
                    attrs: { type: "primary" },
                    on: { click: _vm.handleSubmit },
                  },
                  [_vm._v(_vm._s(_vm.editId ? "Update" : "Create"))]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }